
import { useApiStore } from "@/stores/apiStore";
import { defineComponent } from "vue";
import { AxiosError } from "axios";

export default defineComponent({
	setup() {
		const api = useApiStore();
		return {
			api
		};
	},
	name: "imdex-forgot-password",
	data: () => {
		return {
			// eslint-disable-next-line
			loginWithRedirect: {} as any,
			isAuthenticated: false,
			email: "",
			isLoading: false,
			errorMessage: "",
			success: false
		};
	},
	watch: {
		isAuthenticated(v) {
			if (v) {
				this.$router.push("/users");
			}
		}
	},
	methods: {
		login() {
			this.loginWithRedirect();
		},
		async submitForgotPassword() {
			this.isLoading = true;
			this.errorMessage = "";
			try {
				await this.api.post({ endpoint: "/recover-password", post: { email: this.email } });
				this.isLoading = false;
				this.success = true;
			} catch (e) {
				if (e instanceof AxiosError) {
					if (e.response != null) {
						this.errorMessage = e.response.data.message || e.response.data;
					}
				} else {
					this.errorMessage = this.$t("forgotPassword.problemResetting");
				}
				this.isLoading = false;
			}
		},
		forgot(type: string) {
			console.log(type);
		}
	}
});
